<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-tabs v-model="active" type="border-card" @tab-click="handleClick">
        <el-tab-pane name="1">
          <span slot="label"><i class="el-icon-user-solid"></i> 评测详细流水</span>
          <personal />
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label"><i class="el-icon-s-grid"></i> 评测统计</span>
          <total />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import personal from '@/views/yizhongDong/examine/info/components/class/personal.vue';
import total from '@/views/yizhongDong/examine/info/components/class/total.vue';

export default {
  name: 'GradeInfomation',
  components: { personal, total },
  data () {
    return {
      active: '1',
    };
  },
  methods: {
    handleClick (tab, event) {
      tab.$children[0].$refs.table.reload();
    },
  },
};
</script>

<style scoped></style>
